import { EmailTemplateFormInputParameters } from './types';

export const emailFormInputs: EmailTemplateFormInputParameters[] = [
  { name: 'sentEvent', title: 'SENT-WHEN (EVENT)', required: true, autoFocus: true },
  { name: 'bccTo', title: 'BCC-TO', required: false },
  { name: 'sendTo', title: 'SEND TO', required: true },
  { name: 'templateSubject', title: 'TEMPLATE SUBJECT', required: true },
  { name: 'templateBody', title: 'TEMPLATE BODY', required: true },
  { name: 'supportEmail', title: 'TEMPLATE SIGNATURE EMAIL', required: false },
];
